const category = 'AppSpecificInvestigation';

const cards = [
    {
        name: "Claim Investigation",
        id: "claimInvestigation",
        fields: [
            [
                {
                    type: "content",
                    content: `
              <p>Prior to denying a claim, the issuer is required to perform an investigation.  QFD supports several ways of enforcing or conducting this process:</p>
              <p><strong>Anytime Investigation:</strong> Notes can be entered at any time on a fraud claim from the overview, but no specific assignment is created directing a user to complete it</p>
              <p><strong>Assignment Investigation:</strong> A specific assignment is created for each claim where notes can be entered from an investigation.  A number of findings can be required in order to complete the assignment.  If not completed, the assignment is removed upon claim resolution but can be completed from the overview at any time</p>
              <p><strong>Disabled:</strong> This functionality is not required or does not apply</p>
            `,
                },
            ],
            [{ id: "UseInvestigationOption" }],
            [{ id: "ARIAEnabled" }],
            [{ id: "ARIAAuthProfileName" }],
            [{ id: "ARIAShouldUseClientTransactionData" }],
            [{ id: "ARIAAutoDecision" }],
            [{ id: "ARIAReviewDecisionDeadlineHours" }],
            [{ id: "InvestigationNumberOfItemsRequired" }],
            [{ id: "InvestigationAllowCustomHeaders" }],
            [
                {
                    id: "InvestigationHeaderList",
                    listItems: ["Label", "AutoAddItem", "RequiredForCompletion", "FilterCriteria", "ItemList", "AllowCustomResults"],
                },
            ],
        ],
    },
    {
        name: "Denial Configuration",
        id: "denialConfiguration",
        fields: [
            [
                {
                    id: "UseBODenyReasonConfiguration",
                    groupType: "checklist",
                    layout: [
                        [{ id: "ATMDeposit" }],
                        [{ id: "CreditVoucherAccepted" }],
                        [{ id: "DepositNotReceived" }],
                        [{ id: "DuplicateDispute" }],
                        [{ id: "MerchantCredit" }],
                        [{ id: "MoneyTransfer" }],
                        [{ id: "NoError" }],
                        [{ id: "NeverPosted" }],
                        [{ id: "OutOfTimeframe" }],
                        [{ id: "PaymentCorrected" }],
                        [{ id: "PostedLate" }],
                        [{ id: "ProofOfAuthorization" }],
                        [{ id: "ResolvedAsProcessed" }],
                        [{ id: "ValidCardPresent" }],
                        [{ id: "Withdrawn" }],
                    ],
                },
            ],
            [{ id: "AreDenyCommentsRequired" }],
        ],
    },
];

export { cards, category };